import React, { useState, useEffect } from "react";
import { DEPARTMENTS_DETAILS_LISTING_COLUMNS } from "../../../utils/constant";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  TableSortLabel,
  IconButton,
  Box,
} from "@mui/material";
import RecordNotFound from "../../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_DEPARTMENT_VALIDATIONS } from "../../../utils/Validation";
import AddDepartment from "./AddDepartment";
import Add from "@mui/icons-material/Add";
import { visuallyHidden } from "@mui/utils";
import ClearIcon from "@mui/icons-material/Clear";
import {
  onUpdateDepartmentService,
  departmentsChangeStatusService,
  onAddDepartmentsService,
} from "../../../services/UserOnboardingService";
import useGlobalState from "../../../Context";
import EditIcon from "@mui/icons-material/Edit";
const DepartmentsList = ({
  totalElements,
  departmentsList,
  onSearch,
  fetchDepartmentsList,
  handleTableChanges,
  setLoading,
  showNotification,
  setDepartmentList,
  noRecord,
}) => {
  const [searchedRows, setSearchedRows] = useState(departmentsList);
  const [departmentsNameSearch, setdepartmentsNameSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  // const [searchwith, setSearchwith] = useState("");
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openAddDepartmentsDialog, setOpenAddDepartmentsDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [departmentId, setDepartmentsId] = useState("");
  const [selected, setSelected] = useState([]);
  const [clearSearch, setClearSearch] = useState(false);
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [sortValue, setSortValue] = useState("ASC");
  const [searchValue_, setsearchValue_] = useState(null);
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserInfo = auth.ldapParam;
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserInfo.userId,
    active: 1,
    modifiedBy: loginUserInfo.userId,
  });
  const formOption = {
    resolver: yupResolver(ADD_DEPARTMENT_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
    setValue
  } = useForm(formOption);

  useEffect(() => {
    reset(formData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAddDepartmentsDialog]);

  useEffect(() => {
   
    setSearchedRows(departmentsList);
  }, [departmentsNameSearch, departmentsList]);

  const searchText = async (e) => {
    setSearchValue(e.target.value);
    // setSearchwith("");
    setdepartmentsNameSearch("");
    e.target.value === "" ? setClearSearch(false) : setClearSearch(true);
    if (e.target.value === "") {
      onclickClear();
    }
  };

  const handleClickOpenDepartmentDialog = () => {
    setFormValues({
      createdOn: new Date(),
      createdBy: loginUserInfo.userId,
      modifiedBy: loginUserInfo.userId,
    });
    setOpenAddDepartmentsDialog(true);
  };

  const handleCloseDepartmentDialog = () => {
    setOpenAddDepartmentsDialog(false);
    setIsEditMode(false);
    setIsUpdateButton(true);
    setFormData({});
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
    
      const requestBody = {
        status: true,
        pageNumber: 0,
        pageSize: rowsPerPage ?? 10,
        isAsc: order,
        orderBy: orderBy,
        search: searchValue && searchValue.trim(),
      };
      setIsSearchBtnClick(true);
      setsearchValue_(searchValue)
      await onSearch(requestBody, searchValue && searchValue.trim());
      setSelected([]);
      setDisbaleUpdateButton(true)
      setPage(0);
      setMaxPage(0)
     
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch Departments details");
    } finally {
      setLoading(false);
    }
    // setSearchwith(type);
    setdepartmentsNameSearch(searchValue && searchValue.trim());
  };

  const onclickClear = async () => {
   
    const requestBody = {
      status: true,
      page: page,
      pageSize: rowsPerPage ?? 10,
      isAsc: true,
      orderBy: orderBy,
     
    };
    setsearchValue_(null);
    await fetchDepartmentsList("name", false,null,requestBody);
    setSelected([]);
    setDisbaleUpdateButton(true)
    setSearchValue("");
    setPage(0);
    setMaxPage(0);
    setClearSearch(false);
    setdepartmentsNameSearch("");
    setIsSearchBtnClick(false);
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    await handleTableChanges(paginationValues, false, sortValue, orderBy, searchValue_);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(paginationValues, true, sortValue, orderBy, searchValue_);
    }
    setPage(newPage);
  };

  const onAddEditDepartmentSubmit = async (data) => {
    try {
      let obj = {
        deptCode: data.deptCode.trim(),
        name: data.name.trim(),
        departmentId: departmentId ? departmentId : null,
        modifiedOn: formValues.createdOn,
        modifiedBy: formValues.modifiedBy,
        createdOn: formValues.createdOn,
        createdBy: formValues.createdBy,
        active: true,
      };
      
      const res = !isEditMode
        ? await onAddDepartmentsService(obj)
        : await onUpdateDepartmentService(obj);
      if (res.statusCode === 6) {
        const newDepartmentList = [...departmentsList];
        const index = newDepartmentList.findIndex(
          (x) => x.departmentId === departmentId
        );
        newDepartmentList[index] = { ...departmentsList[index], ...obj };
        setDepartmentList(newDepartmentList);
        handleCloseDepartmentDialog(false);
        setIsUpdateButton(true);
        setSelected([]); setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
        onclickClear()
        // await fetchDepartmentsList("name", true);
        // setPage(0);
        // setMaxPage(0);
       
      } else {
        showNotification("Error", res.message, "error");
        handleCloseDepartmentDialog(false);
      }
    } catch (err) {
      console.log("err catch", err);
      throw err;
    }
  };

  const handleClickEditDepartment = (item) => {
    if (item) {
      reset(item);
    }
    setOpenAddDepartmentsDialog(true);
    setIsEditMode(true);
    setDepartmentsId(item?.departmentId);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item.createdBy ? item.createdBy : 1,
      active: item?.active ? item.active : 0,
      modifiedBy: loginUserInfo.userId,
    });
    setFormData({ ...item });
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - departmentsList.length) : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = departmentsList.map((currentRow) => {
      if (currentRow.departmentId === id) {
        return {
          ...currentRow,
          active: event.target.checked,
        };
      }
      return currentRow;
    });
    setDepartmentList(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = departmentsList.find(
        (record) => record.departmentId === itemId
      );
      if (tempItem) {
        resultRecords.push({
          active: tempItem.active,
          departmentId: tempItem.departmentId,
        });
      }
    });
    try {
      const res = await departmentsChangeStatusService(resultRecords);
      if (res.statusCode === 6) {
        // await fetchDepartmentsList("name", true);
        setSelected([]);
        showNotification("Success", res.message, "success");
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const paginationData={
      page: 0,
      pageSize: rowsPerPage,
      isAsc: order,
      orderBy: orderBy
     };

     setSelected([]);
     setDisbaleUpdateButton(true)

    fetchDepartmentsList(property, isAsc, searchValue_&& searchValue_.trim(), paginationData);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
    //setSearchValue("");
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid container spacing={2} sx={{ px: 0 }} display="flex">
          <Grid item xs={6} md={4}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6"
            >
              Departments Listing ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={6} md={8}>
            <Typography align="right">
              <div className="searchContainer">
                <input
                  type="text"
                  placeholder="By Name or Code"
                  onChange={searchText}
                  className="searchInput2"
                  value={searchValue}
                />
                 <IconButton disabled={searchValue === ""} className={searchValue === "" ? 'searchIcon':'filPrimaryColor searchIcon'}>
                <SearchIcon
                  //className="searchIcon"
                  onClick={() => searchOnClick("firstName")}
                />
                </IconButton>
                {clearSearch && (
                  <ClearIcon
                    sx={{ fontSize: "22px", color: "red" }}
                    className="searchClear"
                    onClick={onclickClear}
                  />
                )}
              </div>
              <Tooltip title="Add department">
                <Button
                  variant="contained"
                  onClick={() => {
                    handleClickOpenDepartmentDialog();
                  }}
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  startIcon={<Add />}
                >
                  Add Department
                </Button>
              </Tooltip>
              <Tooltip title="Update Department Status">
                <Button
                  variant="contained"
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  onClick={onChangeStatusSubmit}
                  disabled={disableUpdateButton}
                >
                  Status Update
                  {selected.length !== 0 &&
                    ` (${Object.keys(selected).length})`}
                </Button>
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={4} sx={{ mt: 2 }}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  // sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size="small"
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    // onSelectAllClick={handleSelectAllClick}
                    rowCount={searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.departmentId);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              key={row.departmentId}
                            >
                              <TableCell size="small" key={"deptCode"}>
                                {row["deptCode"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                key={"name"}
                                title={
                                  row?.name ? row.name : ""
                                }
                              >
                                {(row.name &&
                                  row.name?.slice(0, 20)) ||
                                  "-"}
                                {row.name &&
                                  row.name.length > 20
                                  ? "..."
                                  : ""}{" "}
                              </TableCell>
                              {/* <TableCell size="small" key={"name"}>
                                {row["name"] ?? "-"}
                              </TableCell> */}
                              <TableCell align="left">
                                {" "}
                                <Checkbox
                                  color="primary"
                                  // checked={row.active}
                                  checked={(isItemSelected, row.active)}
                                  classes={{root: 'custom-checkbox-root'}}
                                  onClick={(event) =>
                                    handleActiveChange(event, row.departmentId)
                                  }
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                              <EditIcon
                                  sx={{
                                    fontSize: "20px",
                                    cursor: "pointer",
                                    color: "#567aac",
                                    height: "18px", 
                                    width: "18px" 
                                  }}
                                  //className="brandSearchClear"
                                  onClick={() => handleClickEditDepartment(row)}
                                />
                                
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}
                        >
                          <TableCell colSpan={4} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={4}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={4} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddDepartment
              openDialog={openAddDepartmentsDialog}
              handleClose={handleCloseDepartmentDialog}
              register={register}
              setError={setError}
              handleSubmit={handleSubmit}
              errors={errors}
              onAddEditDepartmentSubmit={onAddEditDepartmentSubmit}
              isEditMode={isEditMode}
              isUpdateButton={isUpdateButton}
              setIsUpdateButton={setIsUpdateButton}
              setValue = {setValue}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default DepartmentsList;

function EnhancedTableHead({ onRequestSort, order, orderBy }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow key={"1"}>
        {DEPARTMENTS_DETAILS_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.departmentId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                (headCell.id === "action" || headCell.id === "active") && true
              }
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
